import type { Reducer } from 'redux';
import type {
    ResendIdVerificationAction,
    ResendIdVerificationSuccessAction,
    ResendIdVerificationFailureAction,
    ClearResendIdVerificationAction
} from '../actionTypes/complianceActionTypes';
import {
    RESEND_ID_VERIFICATION_REQUEST,
    RESEND_ID_VERIFICATION_SUCCESS,
    RESEND_ID_VERIFICATION_FAILURE,
    CLEAR_RESEND_ID_VERIFICATION
} from '../actionTypes/complianceActionTypes';

type ResendIdVerificationState = {
    data: any;
    isLoading: boolean;
    error: any;
};

export const ResendIdVerificationInitialState: ResendIdVerificationState = {
    data: null,
    isLoading: false,
    error: null
};

export type ResendIdVerificationReducer = Reducer<ResendIdVerificationState>;

type ResendIdVerificationActions =
    | ResendIdVerificationAction
    | ResendIdVerificationSuccessAction
    | ResendIdVerificationFailureAction
    | ClearResendIdVerificationAction;

export const reducer: Reducer<ResendIdVerificationState> = (
    state = ResendIdVerificationInitialState,
    action: ResendIdVerificationActions
) => {
    switch (action.type) {
        case RESEND_ID_VERIFICATION_REQUEST:
            return {
                ...state,
                isLoading: true,
                error: null
            };
        case RESEND_ID_VERIFICATION_SUCCESS:
            return {
                ...state,
                isLoading: false,
                data: action.payload,
                error: null
            };
        case RESEND_ID_VERIFICATION_FAILURE:
            return {
                ...state,
                isLoading: false,
                error: action.payload
            };
        case CLEAR_RESEND_ID_VERIFICATION:
            return ResendIdVerificationInitialState;
        default:
            return state;
    }
};
